<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('contact_page')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction"/>
    </div>
</template>

<script>
    import {TableHelpers} from './mixins/TableHelpers';
    import * as actions from '../../../../Config/ApiUrl';
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
    import {formatDateToLocal, onlyTime, optional} from "../../../../Helpers/Helpers";
    import AppLibrary from "../../../../Helpers/AppLibrary";
 

    export default {
        name: "AllNotification",
        extends: AppLibrary,
        data() {
            return {
                selectedUrl: '',
                tableId: 'all-notifications',
                rowData: {},
                options: {
                    name: 'All Notifications',
                    url: actions.GET_CONTACT,
                    showHeader: true,
                    columns: [
                        {
                            title: this.$t('name'),
                            type: 'text',
                            key: 'name',
                        },
                        {
                            title: this.$t('date'),
                            type: 'object',
                            key: 'created_at',
                            uniqueKey: 'id',
                            modifier: function (created_at, rowData) {
                                return formatDateToLocal(created_at)
                            }
                        },
                        {
                            title: this.$t('time'),
                            type: 'object',
                            key: 'created_at',
                            uniqueKey: 'id',
                            modifier: function (created_at, rowData) {
                                return onlyTime(created_at)
                            }
                        },
                    ],
                     actionObj: [
                        {
                            title: this.$t('edit'),
                            icon: 'edit',
                            type: 'none',
                            

                        },
                    ],
                    filters: [
                        {
                            "title": this.$t('created'),
                            "type": "range-picker",
                            "key": "date",
                            "option": ["today", "thisMonth", "last7Days", "thisYear"]
                        }
                    ],
                    showFilter: true,
                    showSearch: true,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: 'desc',
                    actionType: "default",
                }
            }
        },

        methods: {
             getListAction(rowData, actionObj, active) {

                this.rowData = rowData;

                if (actionObj.title == this.$t('edit')) {

                  window.location = `${actions.EDIT_OFFICE}${this.rowData.id}`;
                }
            },
        }
    }
</script>
